<template>
  <q-layout
    view="hHh lpr lfr"
    :class="getEnv === 'stage' ? 'stage-class' : 'prod-class'"
  >
    <HeaderBar />
    <q-page-container>
      <q-page>
        <router-view :key="getEnv" />
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
import HeaderBar from "@/components/header/HeaderBar.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "App",
  data() {
    return {
      account: null,
    };
  },
  inject: ["$msal"],
  components: {
    HeaderBar,
  },

  async created() {
    this.account = this.$msal.getActiveAccount();
    await this.setUser(this.account);

    // Just get token for test purpose
    // setTimeout(() => {
    //   if (this.$msal.isAuthenticated) {
    //     this.$msal.acquireToken().then((token) => {
    //       console.log("testt token", token);
    //     });
    //   }
    // }, 1000);
  },

  computed: {
    // Adding this getEnv as Key into router-view, to check and update all components once the Environment is change by the user
    ...mapGetters({
      getEnv: "selectEnv/getEnv",
    }),
  },

  methods: {
    ...mapActions({
      setUser: "auth/setUser",
    }),
  },
};
</script>

<style lang="scss" scoped>

body {
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: #333;
}

* {
  height: 100%;
}

.stage-class {
  background-color: #fffdf5;
}

.prod-class {
  background-color: #f8f8f8;
}
.q-page-container {
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  max-width: 1232px;
  padding: 0 20px !important;
  margin-top: 50px !important;
}

.q-page-container, .q-page {
  height: calc(100vh - 50px);
}

.q-layout {
  min-height: inherit !important;
}

div {
  :deep(.jsoneditor-menu) {
    background-color: $gray !important;
    border-color: $primary !important;
  }
}
div {
  :deep(.jsoneditor) {
    border-color: $primary !important;
  }
}
</style>
